import { render, staticRenderFns } from "./PointBitcashCancel.vue?vue&type=template&id=5dc377a7"
import script from "./PointBitcashCancel.vue?vue&type=script&lang=js"
export * from "./PointBitcashCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports